import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import CountingEffect from './CountingEffect';
import { OpenInNew, WarningAmber } from '@mui/icons-material';
import { CircularProgress, Tooltip } from '@mui/material';
import { RefreshButton } from '../../../../elements/CustomButtons';

const Widget = ({
  title,
  body,
  percentage,
  range,
  showWarning,
  link,
  loading,
  subtitle,
  onRefresh,
  isFetching,
  showRefreshButton = false,
}) => {
  return (
    <Container>
      <Row>
        <Col>
          <Card className="dashboard-widget">
            <Card.Body className="d-flex flex-column">
              <Card.Title as="h3" className="text-center font-weight-bold">
                {title}
                {link && (
                  <a
                    href={link}
                    title="View in JIRA"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ms-2">
                    <OpenInNew fontSize="small" />
                  </a>
                )}
                {showRefreshButton && !loading && (
                  <RefreshButton
                    onRefresh={onRefresh}
                    isFetching={isFetching}
                    noOutline={true}
                  />
                )}
              </Card.Title>

              <Card.Text
                as="div"
                className="d-flex justify-content-center align-items-center mt-auto">
                {showWarning ? (
                  <div className="mb-2">
                    <Tooltip title="Jira is not integrated">
                      <WarningAmber color="orange" sx={{ fontSize: 64 }} />
                    </Tooltip>
                  </div>
                ) : loading ? (
                  <div className="mb-2">
                    <CircularProgress sx={{ color: 'orange' }} />
                  </div>
                ) : (
                  <>
                    <CountingEffect
                      start={0}
                      end={body || 0}
                      duration={1000}
                      percentage={percentage}
                    />
                    {range && (
                      <p
                        className="text-muted"
                        style={{ fontSize: '12px', marginBottom: 0 }}>
                        {range}&nbsp;
                      </p>
                    )}
                  </>
                )}
              </Card.Text>
              {subtitle && (
                <div className="text-center text-muted" style={{ fontSize: '0.875rem', marginTop: '-0.5rem', marginBottom: '0.5rem' }}>
                  {subtitle}
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Widget;
